import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";


export const AllDonation = createAsyncThunk(
  "/website/donation/all-donation",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Donation.Donations);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSingleDonation = createAsyncThunk(
  "/website/donation/get-donation-single",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await GET(`${APIS.Donation.Donations}/${id}`);


      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const Slice = createSlice({
  name: "donation",
  initialState: {
    all_donation: [],
    single_donation: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(AllDonation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDonation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_donation = action.payload || [];
      })
      .addCase(AllDonation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getSingleDonation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getSingleDonation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.single_donation = action.payload.data || [];
      })
      .addCase(getSingleDonation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
